module.exports = __webpack_public_path__ + "static/media/levc-factory-coventry.542791f4.jpg";